"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageDetails = void 0;
var React = __importStar(require("react"));
var localization_1 = require("@scuf/localization");
var PageDetails = /** @class */ (function (_super) {
    __extends(PageDetails, _super);
    function PageDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageDetails.prototype.render = function () {
        var _a = this.props, totalItems = _a.totalItems, firstItemInCurrentPage = _a.firstItemInCurrentPage, lastItemInCurrentPage = _a.lastItemInCurrentPage, t = _a.t, i18nOf = _a.i18nOf, i18nItems = _a.i18nItems;
        return (React.createElement("span", { className: "page-info" },
            React.createElement("span", { className: "bold" },
                firstItemInCurrentPage,
                " - ",
                lastItemInCurrentPage),
            ' ', i18nOf !== null && i18nOf !== void 0 ? i18nOf : t('of'),
            " ",
            React.createElement("span", { className: "bold" }, totalItems),
            " ", i18nItems !== null && i18nItems !== void 0 ? i18nItems : t('Items')));
    };
    return PageDetails;
}(React.Component));
exports.PageDetails = PageDetails;
exports.default = localization_1.InjectLocalization(PageDetails);
